import SubPage from "./SubPage";

export default class MenuHistory {
    constructor() {
        this.history = [];  // Array to store the menu history
        this.currentIndex = -1;  // Index of the current active menu
    }

    // Helper method to update the UI based on window width
    updateActiveState() {
        if (window.innerWidth <= 992) {
            SubPage.handleMobileActiveState();
        } else {
            SubPage.handleActiveState();
        }
    }

    // Add a menu to the history
    addMenu(menu) {
        // If we are not at the latest history, trim forward history
        if (this.currentIndex < this.history.length - 1) {
            this.history = this.history.slice(0, this.currentIndex + 1);
        }

        this.history.push(menu);  // Add the new menu
        this.currentIndex++;  // Update the current index to the latest menu

        // Update the active state of the UI
        this.updateActiveState();
    }

    // Go back to the previous menu (if possible)
    goBack() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.updateActiveState();  // Update UI when going back
            return this.history[this.currentIndex];
        }
        return null;  // No previous menu
    }

    // Go forward to the next menu (if possible)
    goForward() {
        if (this.currentIndex < this.history.length - 1) {
            this.currentIndex++;
            this.updateActiveState();  // Update UI when going forward
            return this.history[this.currentIndex];
        }
        return null;  // No next menu
    }

    // Get the current active menu 
    getCurrentMenu() {
        if (this.currentIndex >= 0) {
            return this.history[this.currentIndex];
        }
        return null;  // No current menu
    }

    // Get the entire menu history
    getHistory() {
        return this.history;
    }

    // Clear the menu history
    clearHistory() {
        this.history = [];
        this.currentIndex = -1;
    }
}
